import { useEffect, useState } from "react";
import {
  Table,
  Grid,
  Button,
  Loader,
  Tooltip,
  Checkbox,
  Text,
  createStyles,
  Box,
  ScrollArea,
  Group,
  Menu,
  Title,
  Badge,
  Select,
  LoadingOverlay,
  UnstyledButton,
} from "@mantine/core";
import * as dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PageHeading from "../../../../components/PageHeading";
import "./blinkingDot.css";
import AnswersEditModal from "./AnswersEditModal";
import SendEmailModal from "./SendEmailModal";
import SendSmsModal from "./SendSmsModal";
import Pagination from "./Pagination";
import SearchBox from "./SearchBox";
import { useLocation } from "react-router-dom";
import {
  IconPencil,
  IconTrash,
  IconDotsVertical,
  IconSend,
  IconArrowsSort,
  IconMapPin,
  IconTableExport,
  IconTicket,
  IconFile,
  IconPrinter,
} from "@tabler/icons";
import { apiWithInterceptor } from "../../../../api";
const useStyles = createStyles((theme) => ({
  rowSelected: {
    maxHeight: "15px",

    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.fn.rgba(theme.colors[theme.primaryColor][7], 0.2)
        : theme.colors[theme.primaryColor][0],
  },
  th: {
    padding: "0 !important",
  },
  control: {
    width: "100%",
    padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },
  icon: {
    width: 21,
    height: 21,
    borderRadius: 21,
  },
}));

export default function AnswersTable() {
  const [elements, setElements] = useState([]);
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [emailForApproved, setEmailForApproved] = useState(false);
  const [emailForDenied, setEmailForDenied] = useState(false);
  const [emailForSingleTicket, setEmailForSingleTicket] = useState(false);
  const [ticketId, setTicketId] = useState();
  const [opened, setOpened] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [openSms, setOpenSms] = useState(false);
  const [ticketData, setTicketData] = useState();
  const [loading, setLoading] = useState(true);
  const { classes, cx } = useStyles();
  const [selection, setSelection] = useState([]);
  const [ItemPerPage, setItemPerPage] = useState(200);
  const [offset, setOffset] = useState(0);
  const [allFields, setAllFields] = useState([]);
  const [visible, setVisible] = useState(false);
  const [sort, sortBy] = useState(false);
  const [activePage, setPage] = useState(1);
  const [Status, setStatus] = useState("");
  const [displayAttendance, setDisplayAttendance] = useState("Registered");
  const token = JSON.parse(localStorage.getItem("token"));

  const { state } = useLocation();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      event_id: state?.eventID,
    },
  };
  dayjs.extend(utc);
  dayjs.extend(timezone);

  useEffect(() => {
    setLoading(true);
    if (displayAttendance === "Registered") {
      apiWithInterceptor
        .get(
          `/ticket?session_id=${state.sessionID}&limit=${ItemPerPage}&offset=${offset}&status=${Status}`,
          config
        )
        .then((res) => {
          setElements(res.data.array);
          setDisplayAttendance("Registered");
          setLoading(false);
          setData(res.data);
          setRefresh(false);
        })

        .catch((err) => {
          console.log(err);
          setLoading(false);
          setRefresh(false);
        });
    } else {
      apiWithInterceptor
        .get(
          `/attendance?session_id=${state.sessionID}&relations[]=ticket`,
          config
        )
        .then((res) => {
          let flatData = [];
          res.data.array.map((value) => {
            flatData = [...flatData, value.ticket];
          });

          setElements(flatData);
          setDisplayAttendance("Attendance");
          setLoading(false);
          setData(res.data);
          setRefresh(false);
        })

        .catch((err) => {
          console.log(err);
          setLoading(false);
          setRefresh(false);
        });
    }
  }, [refresh, offset, ItemPerPage, Status, displayAttendance]);

  useEffect(() => {
    setVisible(true);
    apiWithInterceptor
      .get(`/form/${state.formID}?relations[]=fields`, config)
      .then((res) => {
        setAllFields(res.data.fields);
        setVisible(false);
      })

      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  }, [refresh]);
  // Select one or all check boxes
  const toggleRow = (id) =>
    setSelection((current) =>
      current.includes(id)
        ? current.filter((item) => item !== id)
        : [...current, id]
    );
  const toggleAll = () =>
    setSelection((current) =>
      current.length === elements?.length
        ? []
        : elements?.map((item) => item.id)
    );
  const rows = elements?.map((element, index) => {
    const selected = selection.includes(element.id);

    return (
      <tr
        className={cx({ [classes.rowSelected]: selected })}
        key={element.id}
        style={{
          maxHeight: "5px",
          padding: "0px",
          backgroundColor:
            element.status === "SENT_APPROVED"
              ? "#67d5af"
              : element.status === "DENIED"
              ? "#F9A8A8"
              : "white",
        }}
      >
        <td style={{ maxHeight: "5px" }}>
          <Box
            style={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Checkbox
              label={index + 1 + 1 * offset}
              checked={selection.includes(element.id)}
              onChange={() => toggleRow(element.id)}
              transitionDuration={0}
            />
          </Box>
        </td>
        <td
          style={{
            maxHeight: "4px",
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          <Text>
            {dayjs(element.created_at).add(3, "hour").format("DD/MM @ hh:mm a")}
          </Text>
        </td>
        <td
          style={{
            maxHeight: "5px",
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          {
            <Tooltip label={element.name}>
              <Text>{element.name}</Text>
            </Tooltip>
          }
        </td>
        <td
          style={{
            maxHeight: "5px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {element.phone_number === null ||
          element.phone_number === "null" ||
          element.phone_number === "" ? (
            <Text
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
              color="red"
              fw={300}
            >
              NA
            </Text>
          ) : (
            <Tooltip label={element.phone_number}>
              <Text>{element.phone_number}</Text>
            </Tooltip>
          )}
        </td>
        <td
          style={{
            maxWidth: "75px",
            maxHeight: "5px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {element.email === null ||
          element.email === "null" ||
          element.email === "" ? (
            <Text
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
              color="red"
              fw={300}
            >
              NA
            </Text>
          ) : (
            <Tooltip label={element.email}>
              <Text>{element.email}</Text>
            </Tooltip>
          )}
        </td>

        {allFields.map((item) => (
          <td
            key={item.id}
            style={{
              maxWidth: "150px",
              maxHeight: "5px",
              padding: "0px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {Array.isArray(element?.data[item.label]) ? (
              item.data_type === "POINT_LOCATION" ? (
                element?.data[item.label][0] !== null ? (
                  item.presentation !== "LOCATION_SELECT" ? (
                    <a
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        textDecoration: "underline",
                        color: "black",
                      }}
                      href={`https://www.google.com/maps/place/${
                        element?.data[item.label][0]
                      },${element?.data[item.label][1]}`}
                      target="_blank"
                      rel="noreferrer"
                      fw={300}
                    >
                      <IconMapPin stroke={1.5} />
                    </a>
                  ) : (
                    <Tooltip
                      multiline
                      width={220}
                      transitionProps={{ duration: 200 }}
                      label={element?.data[item.label][2]}
                    >
                      <Text>{element?.data[item.label][2]}</Text>
                    </Tooltip>
                  )
                ) : (
                  <Text
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                    }}
                    color="red"
                    fw={300}
                  >
                    NA
                  </Text>
                )
              ) : (
                <Tooltip
                  multiline
                  width={220}
                  transitionProps={{ duration: 200 }}
                  label={element?.data[item.label].join(", ")}
                >
                  <Text
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                    }}
                    fw={300}
                  >
                    {element?.data[item.label].join(", ")}
                  </Text>
                </Tooltip>
              )
            ) : element?.data[item.label] === null ||
              element?.data[item.label] === "" ||
              element?.data[item.label] === undefined ||
              element?.data[item.label] === "null" ? (
              <Text
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                color="red"
                fw={300}
              >
                NA
              </Text>
            ) : item.data_type === "FILE" ? (
              <a
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                href={`https://api.ticketin.net/ticket/${
                  element?.data[item.label]
                }`}
                target="_blank"
                rel="noreferrer"
              >
                <IconFile color="black" />
              </a>
            ) : (
              <Tooltip
                style={{
                  whiteSpace: "pre-wrap",
                }}
                multiline={true}
                width={220}
                label={element?.data[item.label]}
              >
                <Text
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                  fw={300}
                >
                  {element?.data[item.label]}
                </Text>
              </Tooltip>
            )}
          </td>
        ))}
        <td
          style={{
            minWidth: "90px",
            maxHeight: "5px",
            padding: "0px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <a
            style={{ marginTop: "10px" }}
            href={`https://ticketin.net/public/ticket?id=${element.id}`}
            target="_blank"
            rel="noreferrer"
          >
            <IconTicket color="black" />
          </a>
        </td>
        <td>
          <a
            style={{ marginTop: "10px" }}
            href={`https://ticketin.net/public/print-ticket?id=${element.id}`}
            target="_blank"
            rel="noreferrer"
          >
            <IconPrinter color="black" />
          </a>
        </td>
        <td
          style={{
            maxHeight: "4px",
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          {element.confirmed === true ? (
            <Text fw="bold">Confirmed</Text>
          ) : (
            <Text fw="bold">Not Confirmed</Text>
          )}
        </td>
        <td
          style={{
            maxHeight: "4px",
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          <Text>{element.type}</Text>
        </td>

        <td style={{ minWidth: "90px", maxHeight: "5px", padding: "0px" }}>
          <Menu position="left">
            <Menu.Target>
              <Button variant="subtle">
                <IconDotsVertical color="black" />
              </Button>
            </Menu.Target>
            <Menu.Dropdown style={{ borderColor: "black" }}>
              <Menu.Label style={{ color: "black" }}>Edit Ticket</Menu.Label>
              <Menu.Item>
                <Tooltip label="Edit">
                  <Button
                    onClick={() => {
                      setOpened(true);
                      setTicketData(element);
                    }}
                    variant="subtle"
                  >
                    <IconPencil color="black" size={20} />
                  </Button>
                </Tooltip>
              </Menu.Item>

              <Menu.Item>
                <Tooltip label="Send Email">
                  <Button
                    onClick={() => {
                      setTicketId(element.id);
                      setEmailForSingleTicket(true);
                      setEmailForDenied(false);
                      setEmailForApproved(false);
                      setOpenEmail(true);
                    }}
                    variant="subtle"
                  >
                    <IconSend color="black" size={20} />
                  </Button>
                </Tooltip>
              </Menu.Item>
              <Menu.Item>
                <Tooltip label="Delete">
                  <Button
                    onClick={() => {
                      setRefresh(true);
                      apiWithInterceptor
                        .delete(`/ticket/${element.id}`, config)
                        .then((res) => {
                          console.log(res);
                          setRefresh(false);
                        })
                        .catch((err) => {
                          console.log(err);
                          setRefresh(false);
                        });
                    }}
                    variant="subtle"
                    color="red"
                  >
                    <IconTrash size={20} />
                  </Button>
                </Tooltip>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </td>
      </tr>
    );
  });

  return loading ? (
    <Grid>
      <Grid.Col
        xs={12}
        lg={12}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader color="yellow" size={100} />
      </Grid.Col>
    </Grid>
  ) : (
    <PageHeading>
      <Grid>
        <>
          <Grid.Col
            xs={12}
            lg={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Badge
              fz="lg"
              fw={600}
              variant="outline"
              size="xl"
              leftSection={<Box className="circle orange" />}
            >
              Total Tickets Received ({data.count})
            </Badge>
            <Title order={3} size="h3">
              Tickets of ({state.sessionName})'s Session
            </Title>
          </Grid.Col>
          <Grid.Col
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            xs={12}
          >
            <SearchBox
              setVisible={setVisible}
              state={state}
              setData={setData}
              setElements={setElements}
              offset={offset}
              ItemPerPage={ItemPerPage}
            />
          </Grid.Col>
          <Grid.Col
            xs={12}
            lg={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Group>
              <Button
                onClick={() => {
                  setOpenSms(true);
                }}
                style={{ width: "150px" }}
                rightIcon={<IconSend size={15} />}
              >
                Send SMS
              </Button>
              <Button
                onClick={() => {
                  setOpenEmail(true);
                  setEmailForApproved(true);
                  setEmailForDenied(false);
                }}
                style={{ width: "150px" }}
                rightIcon={<IconSend size={15} />}
              >
                Email Approved
              </Button>
              <Button
                onClick={() => {
                  setEmailForDenied(true);
                  setEmailForApproved(false);
                  setOpenEmail(true);
                }}
                color="red"
                rightIcon={<IconSend size={15} />}
                style={{ width: "150px" }}
              >
                Email Denied
              </Button>

              <Button
                disabled={selection.length === 0 ? true : false}
                variant="filled"
                style={{ width: "150px" }}
                onClick={() => {
                  setRefresh(true);
                  apiWithInterceptor
                    .patch(
                      `/ticket/bulk/status-update`,
                      {
                        ticket_ids: selection,
                        status: "APPROVED",
                      },
                      config
                    )
                    .then(() => {
                      setRefresh(false);
                    });
                }}
              >
                Approve (
                {selection.length === 1
                  ? `${selection.length} Ticket`
                  : `${selection.length} Tickets`}
                )
              </Button>

              <Button
                disabled={selection.length === 0 ? true : false}
                variant="filled"
                color="red"
                style={{ width: "150px" }}
                onClick={() => {
                  setRefresh(true);
                  apiWithInterceptor
                    .patch(
                      `/ticket/bulk/status-update`,
                      {
                        ticket_ids: selection,
                        status: "DENIED",
                      },
                      config
                    )
                    .then(() => {
                      setRefresh(false);
                    });
                }}
              >
                Deny (
                {selection.length === 1
                  ? `${selection.length} Ticket`
                  : `${selection.length} Tickets`}
                )
              </Button>

              <Button
                rightIcon={<IconTableExport size={15} />}
                style={{ width: "150px" }}
                onClick={() => {
                  apiWithInterceptor
                    .get(`/session/excel/${state.sessionID}`, {
                      ...config,
                      responseType: "blob",
                    })
                    .then((response) => {
                      // handle success
                      const url = window.URL.createObjectURL(
                        new Blob([response.data])
                      );

                      const link = document.createElement("a");
                      link.href = url;
                      link.setAttribute(
                        "download",
                        `${state.sessionName}.xlsx`
                      );
                      document.body.appendChild(link);
                      link.click();
                    })
                    .catch((error) => {
                      // handle error
                    });
                }}
              >
                Export Excel
              </Button>
            </Group>
          </Grid.Col>
          <Grid.Col
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Group style={{ marginRight: "10px" }}>
              <Text size="md" fw="bold">
                Show tickets by Registered / Attendance
              </Text>
              <Select
                placeholder="Show ticket by"
                style={{
                  width: "120px",
                }}
                data={[
                  { label: "Registered", value: "Registered" },
                  { label: "Attendance", value: "Attendance" },
                ]}
                allowDeselect
                value={displayAttendance}
                onChange={(val) => {
                  setDisplayAttendance(val);
                }}
              />
            </Group>
            <Group style={{ marginRight: "10px" }}>
              <Text size="md" fw="bold">
                Show by status
              </Text>
              <Select
                placeholder="Select Status"
                style={{
                  width: "120px",
                }}
                data={[
                  { label: "All", value: "" },
                  { label: "Approved", value: "APPROVED" },
                  { label: "Denied", value: "DENIED" },
                  { label: "Waiting", value: "WAITING" },
                  { label: "Sent email", value: "SENT_APPROVED" },
                ]}
                allowDeselect
                value={Status}
                onChange={(val) => {
                  setStatus(val);
                }}
              />
            </Group>
            <Pagination
              setOffset={setOffset}
              total={data.count}
              ItemPerPage={ItemPerPage}
              setPage={setPage}
              activePage={activePage}
              setItemPerPage={setItemPerPage}
            />
          </Grid.Col>
          <Grid.Col
            xs={12}
            xl={12}
            lg={12}
            sx={{
              display: "flex",
              maxHeight: "600px",
              minHeight: "600px",
              overflow: "auto",
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: "#edb40d",
            }}
          >
            <ScrollArea>
              <Table
                withBorder
                withColumnBorders
                fontSize="md"
                sx={{
                  fontWeight: "300",
                  borderCollapse: "unset",
                  boxSizing: "undset",
                }}
                verticalSpacing="sm"
              >
                <LoadingOverlay visible={visible} overlayBlur={2} />
                <thead>
                  <tr
                    style={{
                      position: "sticky",
                      top: "0",
                      backgroundColor: "white",
                      zIndex: "3",
                    }}
                  >
                    <th>
                      <Box
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Tooltip label="Select/Deselect all">
                          <Checkbox
                            style={{ color: "black", fontWeight: "900" }}
                            onChange={toggleAll}
                            checked={selection.length === elements.length}
                            indeterminate={
                              selection.length > 0 &&
                              selection.length !== elements.length
                            }
                            transitionDuration={0}
                          />
                        </Tooltip>
                      </Box>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Register date
                      </Text>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Full name
                      </Text>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Phone Number
                      </Text>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        E-mail
                      </Text>
                    </th>
                    {allFields.map((item, index) => (
                      <th key={index}>
                        {item.data_type !== "POINT_LOCATION" ? (
                          <UnstyledButton
                            style={{
                              color: "black",
                              fontWeight: "900",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => {
                              sortBy(!sort);
                              sort === false
                                ? apiWithInterceptor
                                    .post(
                                      `/session/sort/${state.sessionID}?limit=${ItemPerPage}&offset=${offset}`,
                                      {
                                        field_name: item.label,
                                        ascending: "ASC",
                                      },
                                      config
                                    )
                                    .then((res) => {
                                      setElements(res.data);
                                    })
                                : apiWithInterceptor
                                    .post(
                                      `/session/sort/${state.sessionID}?limit=${ItemPerPage}&offset=${offset}`,
                                      {
                                        field_name: item.label,
                                        ascending: "DESC",
                                      },
                                      config
                                    )
                                    .then((res) => {
                                      setElements(res.data);
                                    });
                            }}
                          >
                            {item.label}
                            <IconArrowsSort size={14} />
                          </UnstyledButton>
                        ) : (
                          <Text
                            style={{
                              color: "black",
                              fontWeight: "900",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {item.label}
                          </Text>
                        )}
                      </th>
                    ))}
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Ticket
                      </Text>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Save PDF
                      </Text>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <UnstyledButton
                        style={{
                          color: "black",
                          fontWeight: "900",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => {
                          sortBy(!sort);
                          sort === false
                            ? apiWithInterceptor
                                .post(
                                  `/session/sort/${state.sessionID}?limit=${ItemPerPage}&offset=${offset}`,
                                  {
                                    field_name: "confirmed",
                                    ascending: "ASC",
                                  },
                                  config
                                )
                                .then((res) => {
                                  setElements(res.data);
                                })
                            : apiWithInterceptor
                                .post(
                                  `/session/sort/${state.sessionID}?limit=${ItemPerPage}&offset=${offset}`,
                                  {
                                    field_name: "confirmed",
                                    ascending: "DESC",
                                  },
                                  config
                                )
                                .then((res) => {
                                  setElements(res.data);
                                });
                        }}
                      >
                        Confirmation
                        <IconArrowsSort size={14} />
                      </UnstyledButton>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Type
                      </Text>
                    </th>
                    <th style={{ color: "black", fontWeight: "900" }}>
                      <Text
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Edit
                      </Text>
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    padding: "0px",
                  }}
                >
                  {elements.length >= 1 ? (
                    rows
                  ) : (
                    <tr
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <td>
                        <Text weight={500}>No answers found </Text>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ScrollArea>
          </Grid.Col>
          <Grid.Col
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Pagination
              setOffset={setOffset}
              total={data.count}
              ItemPerPage={ItemPerPage}
              setPage={setPage}
              activePage={activePage}
              setItemPerPage={setItemPerPage}
            />
          </Grid.Col>
        </>
      </Grid>
      {opened && ticketData && (
        <AnswersEditModal
          opened={opened}
          setRefresh={setRefresh}
          setOpened={setOpened}
          element={ticketData}
          id={ticketData.id}
        />
      )}
      {openEmail && (
        <SendEmailModal
          opened={openEmail}
          setOpenEmail={setOpenEmail}
          sessionId={state.sessionID}
          emailForApproved={emailForApproved}
          emailForDenied={emailForDenied}
          emailForSingleTicket={emailForSingleTicket}
          ticketId={ticketId}
        />
      )}

      {openSms && (
        <SendSmsModal
          opened={openSms}
          setOpenSms={setOpenSms}
          sessionId={state.sessionID}
        />
      )}
    </PageHeading>
  );
}
